import { getRegisterFunction } from '../../utils/register.js';
import { OneUxInteractiveContentElement } from './OneUxInteractiveContentElement.js';
export const register = getRegisterFunction(OneUxInteractiveContentElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-interactive-content': OneUxInteractiveContentElement;
    "interactive-content-f4ce4e31edc711a5f087e5137aa044d1": OneUxInteractiveContentElement;
  }
}